import { Role } from 'src/enums/enum';

export const isReadOnlyRole = (role: Role) => role === Role.READ;
export const isReadWriteRole = (role: Role) => role === Role.READ_WRITE;
